import React, { Component } from 'react'
import { connect } from 'react-redux'
import Modal from '../../basic-component/Modal'
import Profile from '../Profile/Profile'
import './NavBar.css'
// import dp from '../../assets/img/deepak.JPG'
// import dp from '../assets/img/deepak.JPG'
class NavBar extends Component {
  

  render() {
    return (
      <div>
      <Modal header="Your Profile" modalWidth="modal-xl" modalId="myProfile" action="Update Profile"><Profile /></Modal>
      <Modal header="We are in Progres" modalWidth="modal-sm" modalId="progress" action="">This is in Progress.. You will see soon. :)</Modal>
      <div className=" row " style={{ height: '100%' }, { width: '100%' }}>
        {/* <div className="input-group col-4">
          <span className="fa fa-close" onClick={() => this.props.hideSideBar()}></span>
        </div> */}
        <div className="col-7">
        <ul className="navbar-notification nav-icon align-middle">
            <li  data-toggle="modal" data-target="#progress"><i className="fa fa-envelope " ></i>
              <span className="badge  badge-danger align-top">2</span>
            </li>
            <li  data-toggle="modal" data-target="#progress"><i className="fa fa-bell "> </i>
              <span className="badge badge-danger align-top">3</span>

            </li>
            </ul>
        </div>
        <div className="col-5 text-right ">
          <ul className="navbar-notification">
            {/* <li><i className="fa fa-envelope " ></i>
              <span className="badge  badge-danger">8</span>
            </li>
            <li><i className="fa fa-bell " > </i>
              <span className="badge badge-danger">3</span>

            </li> */}
            <li className="nav-item dropdown">
            <a className="nav-link" href="#" id="navbarDropdown" role="button" data-toggle="dropdown">
            <img src={require("../../assets/img/"+this.props.userDetails.profilePic)} className="nav-profile-img"></img>
          <span className="nav-profile-text">{this.props.userDetails.name}</span>
        </a>
        <div className="dropdown-menu" aria-labelledby="navbarDropdown">
          <a className="dropdown-item"  data-toggle="modal" data-target="#myProfile" ><i className="fa fa-user-o" aria-hidden="true"></i> My Profile</a>
          <a className="dropdown-item"  data-toggle="modal" data-target="#progress"><i className="fa fa-envelope-open-o"aria-hidden="true"></i> inbox</a>
          <div className="dropdown-divider"></div>
          <a className="dropdown-item"  onClick={this.props.logout} ><i className="fa fa-sign-out" aria-hidden="true"></i> Logout</a>
        </div>
            </li>
            {/* <li style={{ marginLeft: "1rem",cursor:"pointer" }} data-toggle="modal" data-target="#myProfile">Deepak Kumar</li>
            <li style={{ marginLeft: "1rem",cursor:"pointer"  }} onClick={this.props.logout}>Logout</li> */}
          </ul>


        </div>
      </div>
      </div>

    );
  }
}
const mapStateToProps = state => {
  return {
      isUserLoggedIn: state.isAuthenticated,
      attendanceData: state.attendanceData
  };
}
const mapDispatchToProps = dispatch => {
  return {
    logout:()=>dispatch({type:"Logout"}),
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(NavBar);

